import {
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Box
} from '@mui/material';
import { useContext } from 'react';
import { DataSourceContext } from 'src/contexts/DataSourceContext';
import {
  DataSourceOverride,
  isDataSourceOverrideEnabled
} from 'src/utils/dataSource';

const OPTIONS: { value: DataSourceOverride; label: string; hint: string }[] = [
  {
    value: 'default',
    label: 'Default',
    hint: 'Use each feature’s configured source'
  },
  {
    value: 'elastic',
    label: 'Elastic',
    hint: 'Legacy Elastic Cloud (prod data)'
  },
  { value: 'aws', label: 'AWS', hint: 'This environment’s AWS account' }
];

/** Test-only header control. Renders nothing unless the override is enabled for this build. */
const DataSourceSelector = () => {
  const { dataSourceOverride, setDataSourceOverride } =
    useContext(DataSourceContext);

  if (!isDataSourceOverrideEnabled()) return null;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography variant="caption" color="text.secondary">
        Data source
      </Typography>
      <ToggleButtonGroup
        size="small"
        exclusive
        value={dataSourceOverride}
        onChange={(_, value: DataSourceOverride | null) => {
          if (value && value !== dataSourceOverride)
            setDataSourceOverride(value);
        }}
        aria-label="Data source override"
      >
        {/* Buttons must be direct children: MUI's group marks the selected one by cloning its
            direct children, so wrapping them (e.g. in a Tooltip) stops the highlight. */}
        {OPTIONS.map((option) => (
          <ToggleButton
            key={option.value}
            value={option.value}
            title={option.hint}
            aria-label={option.hint}
            sx={{ py: 0.25, px: 1 }}
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default DataSourceSelector;
